import React from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Row } from 'react-bootstrap-5';

import { Button } from 'components/ui/button';

export default function ReplaceLogoModal({ newLogoUrl = '', oldLogoUrl = '', show, onConfirm, onHide }) {
  if (!show) return null;

  return (
    <Modal show={show} size="lg" onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Replace Logo?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid confirm-replace">
          <Row className="align-items-center text-center">
            <Col xs={5}>
              <img
                alt="Current logo"
                className="img-fluid"
                src={oldLogoUrl}
                style={{ maxHeight: '200px' }}
              />
            </Col>
            <Col className="text-muted" xs={2}>
              <i className="fas fa-arrow-right fa-5x"></i>
            </Col>
            <Col xs={5}>
              <img
                alt="New logo"
                className="img-fluid"
                src={newLogoUrl}
                style={{ maxHeight: '200px' }}
              />
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-ghost" label="Cancel" variant="secondary" onClick={onHide} />
        <Button label="Replace" onClick={onConfirm} />
      </Modal.Footer>
    </Modal>
  );
}

ReplaceLogoModal.propTypes = {
  newLogoUrl: PropTypes.string,
  oldLogoUrl: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired
};
